import { Vendor } from "../../types/vendorManagement";

export const initialVendors: Vendor[] = [
  {
    id: "vendor-1",
    vendorName: "Tech Innovations Pvt Ltd",
    contactPerson: "Ashraf",
    phoneNumber: "9089054596",
    emailAddress: "techinnovations@gmail.com",
    creditPeriod: 30,
    creditLimit: 50000,
    outstanding: 13000,
    overdueAmount: 11000,
    availableCredit: 37000,
    overdueDays: 29,
    invoices: [
      {
        id: "invoice-1",
        invoiceId: "PRD0004",
        invoiceDate: "20/02/2026",
        amount: 10000,
        paymentDate: "20/02/2026",
        amountPaid: 4000,
        balanceAmount: 6000,
        dueDate: "22/03/2026",
        overdueDays: 19,
        status: "Overdue",
      },
      {
        id: "invoice-2",
        invoiceId: "PRD0032",
        invoiceDate: "10/02/2026",
        amount: 5000,
        paymentDate: "10/02/2026",
        amountPaid: 0,
        balanceAmount: 5000,
        dueDate: "12/03/2026",
        overdueDays: 29,
        status: "Overdue",
      },
      {
        id: "invoice-3",
        invoiceId: "PRD0023",
        invoiceDate: "01/02/2026",
        amount: 8000,
        paymentDate: "01/02/2026",
        amountPaid: 10000,
        balanceAmount: 0,
        dueDate: "03/03/2026",
        overdueDays: 0,
        status: "Paid",
      },
      {
        id: "invoice-4",
        invoiceId: "PRD1234",
        invoiceDate: "--",
        amount: 0,
        paymentDate: "--",
        amountPaid: 0,
        balanceAmount: 2000,
        dueDate: "--",
        overdueDays: 0,
        status: "Opening Balance",
      },
    ],
  },
  {
    id: "vendor-2",
    vendorName: "Green Solutions Pvt Ltd",
    contactPerson: "Rajeev",
    phoneNumber: "7453464577",
    emailAddress: "greensolutions@gmail.com",
    creditPeriod: 45,
    creditLimit: 75000,
    outstanding: 20000,
    overdueAmount: 0,
    availableCredit: 55000,
    overdueDays: 0,
    invoices: [
      {
        id: "invoice-5",
        invoiceId: "PRD0188",
        invoiceDate: "14/03/2026",
        amount: 20000,
        paymentDate: "18/03/2026",
        amountPaid: 20000,
        balanceAmount: 0,
        dueDate: "28/04/2026",
        overdueDays: 0,
        status: "Paid",
      },
    ],
  },
  {
    id: "vendor-3",
    vendorName: "Tech Innovations Pvt Ltd Branch 2",
    contactPerson: "Ashraf",
    phoneNumber: "9089054596",
    emailAddress: "ashraf.branch@gmail.com",
    creditPeriod: 30,
    creditLimit: 60000,
    outstanding: 65000,
    overdueAmount: 10000,
    availableCredit: -5000,
    overdueDays: 12,
    invoices: [
      {
        id: "invoice-6",
        invoiceId: "PRD0099",
        invoiceDate: "03/03/2026",
        amount: 65000,
        paymentDate: "03/03/2026",
        amountPaid: 0,
        balanceAmount: 65000,
        dueDate: "02/04/2026",
        overdueDays: 12,
        status: "Overdue",
      },
    ],
  },
];
